import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getHowToCreateAnchorUrl } from '../../utils/anchor';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function HowToUseAnchorsTooltip({
  i18nKey
}) {
  return /*#__PURE__*/_jsx(Tooltip, {
    use: "longform",
    placement: "top",
    title: /*#__PURE__*/_jsxs(List, {
      styled: true,
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('tooltipInfo1')
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('tooltipInfo2')
        })
      }), /*#__PURE__*/_jsxs(ListItem, {
        marginBlockEnd: "100",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('tooltipInfo3')
        }), ' ', /*#__PURE__*/_jsx(Link, {
          href: getHowToCreateAnchorUrl(),
          external: true,
          children: I18n.text(i18nKey('learnMore'))
        })]
      })]
    }),
    onMouseDown: e => e.preventDefault(),
    children: /*#__PURE__*/_jsx(Link, {
      children: I18n.text(i18nKey('tooltipLinkText'))
    })
  });
}
export function AnchorInputField({
  i18nKey,
  anchorId,
  invalidAnchorId,
  onChange
}) {
  let validationMessage = '';
  if (invalidAnchorId) {
    validationMessage = I18n.text(i18nKey(invalidAnchorId === 'duplicate' ? 'duplicateIdErrorMessage' : 'invalidIdErrorMessage'));
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: I18n.text(i18nKey('nameLabel')),
    marginBlockEnd: "400",
    error: !!invalidAnchorId,
    validationMessage: validationMessage,
    children: /*#__PURE__*/_jsx(TextInput, {
      autoFocus: true,
      autoFocusPreventScroll: true,
      "data-test-id": "anchor-name-input",
      value: anchorId,
      onChange: onChange,
      placeholder: I18n.text(i18nKey('placeholder')),
      maxLength: 50 // Prevent aggressively long anchor ids
    })
  });
}